import { CustomSubscriberTabType } from "./CustomNotificationsAndSignals";
import { BellAlertIcon, CodeBracketIcon } from "@heroicons/react/24/outline";
import React from "react";

interface Props {
  tabType: CustomSubscriberTabType;
  setTabType: (val: CustomSubscriberTabType) => void;
}

export default function CustomSubscribersTabTypeHeader({ tabType, setTabType }: Props): JSX.Element {
  return (
    <div className="hidden sm:block">
      <div>
        <nav className="flex -mb-[2px] space-x-4">
          <a
            onClick={() => {
              setTabType(CustomSubscriberTabType.FORMATTING);
            }}
            className={`cursor-pointer inline-flex items-center px-1 py-4 text-sm font-medium leading-5 border-b-2 group focus:outline-none 
              ${
                tabType === CustomSubscriberTabType.FORMATTING
                  ? "text-gray-800 border-primary-main focus:text-blue-800 focus:border-blue-700"
                  : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300"
              }`}
          >
            <CodeBracketIcon className="-ml-0.5 mr-1 h-5 w-5" />
            <span>Formatting</span>
          </a>
          <a
            onClick={() => {
              setTabType(CustomSubscriberTabType.NOTIFICATIONS);
            }}
            className={`cursor-pointer inline-flex items-center px-1 py-4 text-sm font-medium leading-5 border-b-2 group focus:outline-none 
              ${
                tabType === CustomSubscriberTabType.NOTIFICATIONS
                  ? "text-gray-800 border-primary-main focus:text-blue-800 focus:border-blue-700"
                  : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300"
              }`}
          >
            <BellAlertIcon className="-ml-0.5 mr-1 h-5 w-5" />
            <span>Notifications</span>
          </a>
        </nav>
      </div>
    </div>
  );
}
